module.exports = __webpack_public_path__ + "fonts/Inter-Bold.9aa03c46.woff2";